import React from 'react';
import { SupportingLinkModalComponent } from '../../../components/Modals/SupportingLink';
import { useModal } from '../../../modules/unsw-modals';

export const SupportingLinkModal = () => {
  const { links } = useModal();
  return (
    <SupportingLinkModalComponent
      links={links.map((link, index) => ({
        tabId: index.toString(),
        label: index.toString(),
        link,
      }))}
    />
  );
};
